import ComingSoon from "components/Common/ComingSoon";
import React from "react";

const ShareApplication = () => {
  return (
    <div>
      <ComingSoon />
    </div>
  );
};

export default ShareApplication;
